export default __webpack_public_path__ + "static/failure_patterns-d2df5100f80cbef6c766cd1efe7a579a.png";